import { isFunction } from "lodash";
import LocationService from "../provider/Location/LocationService";
import { CHANGE_APP_PROPS, CHANGE_LOCATION_PROPS } from "./ActionConstants";

export function actionChangeLocationProps(props) {
	return (dispatch, getStore) => {
		dispatch({
			type: CHANGE_LOCATION_PROPS,
			props: props
		});
	};
}
export function actionGetProvinces() {
	return (dispatch, getStore) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true,
				loadingText: "Cargando..."
			}
		});
		asyncGetProvinces()
			.then(resp => {
				dispatch({
					type: CHANGE_LOCATION_PROPS,
					props: {
						provinciasList: resp
					}
				});
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(err => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncGetProvinces() {
	let resp = await LocationService.getProvinces();
	return resp;
}

export function actionGetCities(idProvince, callback) {
	return (dispatch, getStore) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true,
				loadingText: "Cargando..."
			}
		});
		asyncGetCities(idProvince)
			.then(resp => {
				dispatch({
					type: CHANGE_LOCATION_PROPS,
					props: {
						ciudadesList: resp
					}
				});
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
				if (isFunction(callback)) callback();
			})
			.catch(err => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncGetCities(idProvince) {
	let resp = await LocationService.getCitiesofProvice(idProvince);
	return resp;
}



// WEBPACK FOOTER //
// ./src/actions/ProvinceActions.js